import EditarImposto from "../../../components/Cadastros/Editar/EditarImposto";
import Header from "../../../components/Menu";

const EditarImpostoPage = () => {
  return (
    <div className="flex">
      <Header />
      <EditarImposto />
    </div>
  );
};

export default EditarImpostoPage;
